import React, { useEffect, useMemo, useState } from 'react';
import * as ui from '@digital/ui';
import { Steps, Col, Row, Tooltip, Icon } from 'antd';
import { IGroupItemStep, IItemStep, StepPanelProps } from './interfaces';
import { FormikProps } from 'formik';

const StepsPanel = ({
    groupSteps,
    direction = 'vertical',
    header,
    contentLegend,
    actions,
    showAllActions = true,
    showNext = true,
    showPrev = true,
    onNext,
    onPrev,
    numberCurrentStep,
}: StepPanelProps) => {
    const [activeOrdinal, setActiveOrdinal] = useState<number>(0);
    const [allSteps, setAllSteps] = useState<IItemStep[]>([]);
    const [config, setConfig] = useState<any>({
        stepsWidth: '300px',
        stepSpan: 4,
        stepContentSpan: 20,
    });

    const getCurrentStep = (stepNumber?: number): IItemStep | undefined => {
        if (stepNumber === undefined) {
            stepNumber = activeOrdinal;
        }
        
        const index = allSteps.findIndex((item) => item.stepNumber === stepNumber)
        return index >= 0 ? allSteps[index] : undefined;
    };

    useEffect(() => {
        let steps: IItemStep[] = [];

        let count = 0;
        groupSteps
            .sort((a, b) => a.order - b.order)
            .forEach((group: IGroupItemStep) => {
                group.steps.forEach((step: IItemStep) => {

                    if (step.visible == true) {
                        step.order = count;
                        steps.push(step);
                        count++;
                    }

                });
            });

        setAllSteps(steps);
    }, [groupSteps]);

    const actionsMemo = (): React.ReactNode[] => {
        const actionsTemp: React.ReactNode[] = [];

        if (showAllActions && actions) {
            actionsTemp.push(...actions);
        }

        return actionsTemp;
    }

    const renderSidebar = () => useMemo(() => {
        let continueIndex = 0;

        return groupSteps.map((group, index) => {
            let steps = group.steps.filter((step) => step.visible === true) as IItemStep[];
            let contentTemp = (
                group.title ? (
                    <fieldset key={group.title}>
                        <legend id={`mrn-legend-stepv2-sidebar-${group.title}`}>{group.title}</legend>
                        {renderSteps(index, steps, continueIndex)}
                    </fieldset>
                ) :
                    renderSteps(index, steps, continueIndex)
            );

            continueIndex += steps.length;

            return contentTemp;
        });
    }, [groupSteps, activeOrdinal, numberCurrentStep]);

    const renderSteps = (key: number, steps: IItemStep[], init: number) => {
        console.log('steps', steps);
        const index = steps.findIndex((step) => step.stepNumber === numberCurrentStep)
        const currentStep = getCurrentStep(numberCurrentStep);
        let currentOrder = currentStep?.order ?? 0;
        init = steps[0].order ?? 0;

        return <Steps
            key={key + Math.random()}
            initial={key != 0 ? init : 0}
            current={currentOrder ? currentOrder : 0}
            size="small"
            style={{ maxWidth: config.stepsWidth }}
            direction={direction}>
            {steps.map((step) => (
                <Steps.Step
                    key={step.disabled ? null : (step.stepNumber || 0) + Math.random()}
                    title={step.title}
                    status={step.disabled ? 'wait' : undefined}
                    icon={step.icon}
                    description={step.description}
                />
            ))}
        </Steps>
    };

    const renderContent = () => {
        let step = getCurrentStep(numberCurrentStep);
        if (step) {
            return contentLegend ? (
                <fieldset>
                    <legend id={`mrn-legend-stepv2-content`}>{contentLegend}</legend>
                    <>
                        {step.content}
                    </>
                </fieldset>
            ) : (step.content);
        }
        return <p>Conteúdo Indisponível</p>
    };

    return (
        <ui.Widget actions={actionsMemo()}>
            <Row gutter={24}>
                <Col span={config.stepSpan}>
                    {renderSidebar()}
                </Col>

                <Col span={config.stepContentSpan}>
                    {header && header()}
                    {renderContent()}
                </Col>
            </Row>
        </ui.Widget>
    );
};

export default StepsPanel;
